module.exports = __webpack_public_path__ + "img/orange-square-table-1.47a44429.png";